import HeaderContent from './HeaderContent'

export default HeaderContent
